import { useSnapshot } from "valtio"
import { FlowActions, FlowState } from "../../stores/flowStore"

export function useAllActionsCompleted() {
  const { allActionsCompleted } = useSnapshot(FlowState)
  return [allActionsCompleted, FlowActions.setAllActionsCompleted] as const
}
